import { Vue, Component, Prop } from 'vue-property-decorator';
import './index.scss';

@Component
export class LoadingUI extends Vue {
  @Prop({ default: false }) value;
  @Prop({ default: 1 }) type;

  render(createElement) {
    return (
      <div class={`loading-gif--container type-${this.type}`}>
        <div class="loading-gif--box">
          <img src="static/icons/loading.gif" alt="" />
        </div>
      </div>
    )
  }
}

